import Publish from "../components/Publish/Publish";
import Contacts from "../components/Contacts/ContactList";
import CorrectItem from "../components/corrections/CorrectItem";
import {Home} from "../components/dashbord/homePage/Home";
import {ItemForm} from "../components/items/ItemForm";
import {ItemNew} from "../components/items/ItemNew";
import {Items} from "../components/items/Items";
import {UpdateItem} from "../components/items/UpdateItem";
import PurchaseOrder from "../components/Po/PurchaseOrder";
import PurchaseOrderTogo from "../components/Po/PurchaseOrderTogo";
import Receiving from "../components/receiving/Receiving";
import Shipping from "../components/shipping/Shipping";
import Vendors from "../components/vendors/Vendors";
import Warehouse from "../components/warehouse/Warehouse";
import Inventory from '../components/Inventory'
import ProductPurchasing from '../components/purchasing'
import Categories from '../components/categories/CategoriesView'
import ProductFilterView from "../components/ProductFilter/ProductFilterView";
import EmptyItem from "../components/dashbord/EmptyItem";
import {CommandeItem} from "../components/items/CommandeItem";
import {CommandeForm} from "../components/items/CommandeForm";
import SyncErrors from "../components/SyncErrors/SyncErrors";
import Orders from "../components/orders";
import UserManagement from "../components/user-management/UserManagement";
import ErrorLog from "../components/ErrorLog/ErrorLog";
import WarehouseOrders from "../components/vendor-orders";
import Family from "../components/family";
import ItemPDF from "../components/item_pdf/ItemPDF";
import BarcodeGen from 'src/components/barcode_gen'
import AutomatedOrdering from "../components/AutomatedOrdering" 
import PurchaseQuantity from "../components/PurchaseQuantity" 
import ActivePurchase from "../components/ActivePurchase" 
import PurchaseCart from "../components/PurchaseCart" 
//import ManageOrders from "../components/ManageOrders" 

export const routes = [
    {path: "/publish", component: Publish},
    {path: "/contacts", component: Contacts},
    {path: "/", component: Home, exact: true},
    {path: "/items", component: Items},
    {path: "/form", component: ItemForm},
    {path: "/new-item", component: ItemNew},
    {path: "/update-item", component: UpdateItem},
    {path: "/po-manager", component: PurchaseOrder},
    {path: "/togo-po-manager", component: PurchaseOrderTogo},
    {path: "/vendor-manager", component: Vendors},
    {path: "/warehouse-manager", component: Warehouse},
    {path: "/v-orders", component: WarehouseOrders},
    {path: "/receiving-manager", component: Receiving},
    {path: "/shipping-manager", component: Shipping},
    {path: "/correction-manager", component: CorrectItem},
    {path: "/cat-manager", component: Categories},
    {path: "/inventory", component: Inventory},
    {path: "/purchasing", component: ProductPurchasing},
    {path: "/family", component: Family},
    {path: "/sync-errors", component: SyncErrors},
    {path: "/filter-prod", component: ProductFilterView},
    {path: "/empty-prod", component: EmptyItem},
    {path: "/commande-item", component: CommandeItem},
    {path: "/commande-form", component: CommandeForm},
    {path: "/orders", component: Orders},
    {path: "/user-management", component: UserManagement, exact: true},
    {path: "/error-log", component: ErrorLog},
    {path: "/item-pdf", component: ItemPDF},
    {path:'/barcode', component:BarcodeGen},
    {path:'/automated-ordering', component:AutomatedOrdering},
    {path:'/quantity-purchase', component: PurchaseQuantity},
    {path:'/active-purchase', component: ActivePurchase},
    {path:'/cart-purchase', component: PurchaseCart},
    //{path:'/ManageOrders', component: ManageOrders},
]
